﻿/*
 * @class rlAccordion
 * @memberOf jQuery.fn
 */

(function ($) {
    $.fn.rlPreviewPanel = function () {
        $('#previewPanel').each(function(){
            var $previewPanel = $(this);

            // Close the panel.
            $previewPanel.find('[data-rl-preview-panel-close]').on('click', function(e){
                e.preventDefault();
                $previewPanel.fadeOut(350, function(){
                    $previewPanel.hide();
                })
            });

            // Copy the link.
            $previewPanel.find('[data-rl-preview-panel-copy]').on('click', function(e){
                e.preventDefault();
                document.getElementById('previewPanelLink').select();
                document.execCommand('copy');
            })
        });
    }
}(jQuery));